import SquareGrid3x3FilledIconPath from "@ingka/ssr-icon/paths/square-grid-3x3-filled";

export default SquareGrid3x3FilledIconPath;
